import Vue from 'vue';

export default (type = 'show', id, params = {}) => (
  new Promise((resolve, reject) => {
    let request = null;
    if (type === 'show') {
      request = Vue.$http.get(`/bills/pdf_attachment/${id}/load`);
    } else if (type === 'remove') {
      request = Vue.$http.post(`/bills/pdf_attachment/${id}/remove`, params);
    } else if (type === 'revert') {
      request = Vue.$http.post(`/bills/pdf_attachment/${id}/revert`, params);
    } else if (type === 'generate') {
      request = Vue.$http.post(`/bills/original_pdf_attachment/${id}/generate`, params);
    } else if (type === 'exist') {
      request = Vue.$http.post(`/bills/pdf_attachment/${id}/exist`, params);
    }
    request.then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response.data);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/attachmentPdf.js